import { createSlice, PayloadAction } from "@reduxjs/toolkit";


type contactState = {
    data: any,
    displayModal: boolean
    displayModalPM: boolean
    displayMobileMenu: boolean
};

const initialState = {
    data: [],
    displayModal: false,
    displayMobileMenu: false,
    displayModalPM: false

} as contactState;

export const contactSlice = createSlice({
    name: "contactSlice",
    initialState,
    reducers: {

        setData: (state, action: PayloadAction<number>) => {
            state.data = action.payload
        },

        setDisplayModal: (state, action: PayloadAction<boolean>) => {
            state.displayModal = action.payload
        },

        setDisplayModalPM: (state, action: PayloadAction<boolean>) => {
            state.displayModalPM = action.payload
        },

        setDisplayMobileMenu: (state, action: PayloadAction<boolean>) => {
            state.displayMobileMenu = action.payload
        },
    },

});

export const {
    setData,
    setDisplayModal,
    setDisplayMobileMenu,
    setDisplayModalPM
} = contactSlice.actions;
export default contactSlice.reducer;
